module.exports = __webpack_public_path__ + "fonts/NespressoLucas-MedItalic.woff2?v=678547b29069fbf59daa89f44238617e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-MedItalic.woff2
// module id = 668
// module chunks = 0